import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'lookup',
    templateUrl: './lookup.component.html',
    styleUrls: ['lookup.component.less']
})
export class LookupComponent implements OnInit {

    @Input() endpoint: string;
    @Input() selected_item: any;
    @Input() placeholder: any;
    @Input() lookup_data: any;
    @Output() item_selected = new EventEmitter;

    lookup_items: any;
    showResults: Boolean = false;
    lookup_value: any = "";
    timer: any;

    constructor(protected http: HttpClient) {}

    ngOnInit(){
        if (this.endpoint) {
            this.http.get(this.endpoint).subscribe(response => {
                    this.lookup_items = response;
                }, error => {
            });
        } else {
            this.lookup_items = this.lookup_data;
        }
    }
    onLookupClick() {
        this.showResults = !this.showResults;
    }
    onLookupItemSelect(item: any) {
        this.showResults = false;
        this.lookup_value = item.name;
        this.selected_item.setValue(item.id);
        this.item_selected.emit();
    }
    enterList() {
        clearTimeout(this.timer);
    }
    leaveList() {
        this.timer = setTimeout(() => {
            this.showResults = false;
        }, 1000);
    }
}
